
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","getTradeBlotterAfterALotTime","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "f67159a3b1de6d417c7e.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "f67159a3b1de6d417c7e.worker.js");
					addMethods(w, methods)
					
					return w
				}
			